<template>
  <div>
    <Head title="Njoftimet" />
    <h1 class="mb-8 text-3xl font-bold">Njoftimet</h1>


    <div class="flex items-center justify-between mb-6">
      <Link class="btn-indigo" href="njoftimet/regjistro">
        <span>Regjistro</span>
        <span class="hidden md:inline"> Njoftim të ri</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th></th>
          <th class="pb-4 pt-6 px-6">Titulli</th>
          <th class="pb-4 pt-6 px-6">Statusi</th>
          <th class="pb-4 pt-6 px-6">Shfaqur nga</th>
          <th class="pb-4 pt-6 px-6">Shfaqur deri</th>
          <th class="pb-4 pt-6 px-6">Krijuar më</th>
          <th class="pb-4 pt-6 px-6">Edituar më</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="notification in notifications.data" :key="notification.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="w-px border-t px-2 py-4">
            <Link class="flex items-center px-4" :href="`njoftimet/${notification.id}/edit`" tabindex="-1">
              <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
          <td class="border-t px-2">
              {{ notification.title }}
              <icon v-if="notification.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
          </td>
          <td class="border-t px-2">
            {{ notification.status }}
          </td>
          <td class="border-t px-2">
            {{ notification.start_date }}
          </td>
          <td class="border-t px-2">
            {{ notification.end_date }}
          </td>
          <td class="border-t px-2">
              {{ notification.hr_created_at }}
          </td>
          <td class="border-t px-2">
              {{ notification.hr_updated_at }}
          </td>
        </tr>
        <tr v-if="notifications.data.length === 0">
          <td class="px-6 py-4 border-t" colspan="4">Nuk u gjet asnje njoftim.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <pagination class="mt-6" :links="notifications.meta.links" />
  </div>
</template>

<script>
import { Head, Link, usePage } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import mapValues from 'lodash/mapValues'
import Pagination from '@/Shared/Pagination'
import DangerFlashMessage from '@/Shared/DangerFlashMessage'

export default {
  components: {
    DangerFlashMessage,
    Head,
    Icon,
    Link,
    Pagination,
  },
  layout: Layout,
  props: {
    notifications: Object,
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    redirect(notificationId){
      this.$inertia.get('/admin/njoftimet/'+notificationId+'/edit')
    }
  },
}
</script>
